import { ApiComponent } from '@ibe/api';

class InsuranceAddedEvent {
  insurance: ApiComponent | null;
}

export default InsuranceAddedEvent;
